import * as Long from "long";
import * as React from "react";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { utilNumber } from "../../../utils/utilNumber";
import { ButtonDogTreatAddResource } from "../../doghouse/ButtonDogTreatAddResource";
import { IdTooltipAnchor } from "../../tooltip";
import { Badge } from "../badge/Badge";
import { IdBadgePosition } from "../badge/IdBadgePosition";
import { IconWithProgress } from "../icon-with-progress/IconWithProgress";
import { getResourceIcon } from "../icon/getResourceIcon";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { ResourceRequirement, } from "../resource-requirement/ResourceRequirement";
export var ResourceWithThreshold = function (_a) {
    var available = _a.available, onButtonClick = _a.onButtonClick, required = _a.required, resource = _a.resource, styleId = _a.styleId, tooltipLoca = _a.tooltipLoca, _b = _a.tooltipAnchor, tooltipAnchor = _b === void 0 ? IdTooltipAnchor.Bottom : _b, _c = _a.tooltipVerticalAdjust, tooltipVerticalAdjust = _c === void 0 ? -IdTooltipAdjust.Small : _c;
    var icon = getResourceIcon(resource);
    var percent = Long.fromValue(available)
        .multiply(100)
        .divide(required)
        .toNumber();
    var progressPercent = utilNumber.clamp(percent, 0, 100);
    var isComplete = available >= required;
    var fillStyle = isComplete ? IdStyles.ProgressBarFill : IdStyles.ProgressBarIncompleteFill;
    var iconStyle = styleId ? styleId : IdStyles.IconSmall;
    iconStyle = "resource-with-threshold__icon" + (isComplete ? "-complete" : "") + " " + iconStyle;
    return (React.createElement("div", { className: "flex flex--guts resource-with-threshold " + (isComplete ? "resource-with-threshold-complete" : ""), onClick: onButtonClick },
        React.createElement(IconWithProgress, { icon: icon, iconStyle: iconStyle, fillClassName: fillStyle, backgroundClassName: IdStyles.ProgressBarIncompleteBackground, progressPercent: progressPercent, tooltipLoca: tooltipLoca, tooltipVerticalAdjust: tooltipVerticalAdjust, tooltipAnchor: tooltipAnchor },
            React.createElement(ResourceRequirement, { available: available, required: required, styleNegative: IdStyles.TextNormal })),
        isComplete ? (React.createElement(Badge, { position: IdBadgePosition.Right },
            React.createElement(Icon, { icon: IdIcon.QuestFinishIcn, styleId: IdStyles.IconMedium }))) : (React.createElement(ButtonDogTreatAddResource, null))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/resource-with-threshold/ResourceWithThreshold.tsx
// module id = 2816
// module chunks = 3